import { lazyRouteComponent } from "@tanstack/react-router"

export function lazyImportRouteComponent<T>(
  loader: () => Promise<T>,
  exportName: keyof T = "default" as keyof T
) {
  return lazyRouteComponent(() =>
    loader().then((mod) => ({
       
      default: mod[exportName],
    }))
  )
}
